import { AWARD_STATUS } from '@/shared/constants';
import { Box, Tooltip } from '@chakra-ui/react';
import { FiAward } from 'react-icons/fi';

export const LabelAwarded = (props: {
  award: AWARD_STATUS | undefined
}) => {
  const awardBg = props.award === AWARD_STATUS.AWARDED
    ? 'rgba(107,183,69,0.5)' // green
    : props.award === AWARD_STATUS.AWARDED_EDITION
      ? 'rgba(255, 213, 79, 0.7)' // yellow
      : props.award === AWARD_STATUS.WAS_AWARDED
        ? 'rgba(255,255,255,0.5)' // gray
        : props.award === AWARD_STATUS.NOT_AWARDED
          ? 'rgba(255,0,0,0.5)' // red
          : 'none';

  const awardText = props.award === AWARD_STATUS.AWARDED
    ? 'EIT Label awarded (good)'
    : props.award === AWARD_STATUS.AWARDED_EDITION
      ? 'EIT Label awarded to the current edition (satisfactory)'
      : props.award === AWARD_STATUS.WAS_AWARDED
        ? 'EIT Label awarded to the previous run'
        : props.award === AWARD_STATUS.NOT_AWARDED
          ? 'EIT Label not awarded'
          : undefined;

  return awardText && <Tooltip label={awardText}>
    <Box as="span" verticalAlign='middle' display="inline-block"><FiAward fill={awardBg} /></Box>
  </Tooltip>
}
